import { render, staticRenderFns } from "./quesSuccess5.vue?vue&type=template&id=542b28be"
import script from "./quesSuccess5.vue?vue&type=script&lang=js"
export * from "./quesSuccess5.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess5.vue?vue&type=style&index=0&id=542b28be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports